import { useQuery } from '@tanstack/react-query';

import { AllowedTimes } from 'src/features/membershipType/types';
import axios from 'src/lib/axios';
import { ListResponseSmartParkAPI } from 'src/lib/queries';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/memberships/membership-type/:membershipTypeId/allowed-times/`;

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    parkingId: string;
    membershipTypeId: string;
}
const queryFn = ({ parkingId, membershipTypeId, ...params }: DTO): Promise<ListResponseSmartParkAPI<AllowedTimes>> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, membershipTypeId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_ALLOWED_TIMES_RESOURCE, useQueryHook as useListMembershipTypeAllowedTimes };
